import { Component, OnInit, ViewChild } from '@angular/core';
import { VerUsuariosComponent } from '../../../forms/usuarios/ver-usuarios/ver-usuarios.component';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent implements OnInit {
  @ViewChild('verUsuarios') verUsuarios: VerUsuariosComponent;

  constructor() { }

  ngOnInit() { }

  actualizarTabla(): void {
    this.verUsuarios.actualizarTabla();
  }
}